import Maybe from 'components/__new/common/Maybe';
import { ButtonLoader, SelectInput } from 'components/__new/common/form'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import validate from 'utils/validate';
import { ReactComponent as IconReturn } from "assets/images/icons/project-icons/get-started-back.svg"
import { ReactComponent as StatementUpload } from "assets/images/icons/project-icons/statement-upload.svg"
import { ReactComponent as HourGlass } from "assets/images/icons/project-icons/hourglass.svg"
import { FileUploader } from 'react-drag-drop-files';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import getFileSize from 'utils/getFileSize';
import numberOrdinalSuffix from 'utils/numberOrdinalSuffix';
import { useDispatch, useSelector } from 'react-redux';
import { saveOnDemandOnboarding, submitOnboardingForm } from 'store/entities/dashboard/action';
import useMediaService from 'hooks/useMediaService';
import Spinner from 'components/__new/common/Spinner';
import DynamicHeadTag from 'components/__new/common/DynamicHeadTag';

const OnDemandOnboarding = () => {
    const dispatch = useDispatch();
    const [tab, setTab] = useState(1);
    const [statementDoc, setStatementDoc] = useState(null);
    const { uploadFile, uploadLoading } = useMediaService();
    const { onDemandOnboardingForm, submitOnboardingLoading, submitOnboardingData } = useSelector((state) => state.entities.dashboard);
    
    
    const [form, setForm] = useState({
        onDemandPayrollCutOff: "",
        onDemandPaymentFee: "",
        autoWithdrawals: null,
    })    
    
    const onStepOneComplete = async (e) => {
        e.preventDefault();

        const validateForm = {...form};
        const errors = validate(validateForm);
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            const payload = {
                ...form,
                autoWithdrawals: form.autoWithdrawals === "true" ? true : false
            }
            dispatch(saveOnDemandOnboarding(payload));
            setTab(2);
        }
    }
    
    const onStepTwoComplete = async () => { 
        if(!statementDoc) {
            toast.error("Please upload a bank statement")
        } else {
            const response = await uploadFile(statementDoc);
            if(response?.status === "success") {
                const payload = {
                    payrollCutOff: onDemandOnboardingForm?.onDemandPayrollCutOff,
                    paymentFee: onDemandOnboardingForm?.onDemandPaymentFee,
                    withdrawalPercent: 50,
                    autoWithdrawals: onDemandOnboardingForm?.autoWithdrawals,
                    bankStatementFile: response?.data?.url
                }
                dispatch(submitOnboardingForm(payload));
            }
            
        }
    }
    
    useEffect(() => {
        if(onDemandOnboardingForm !== null) {
            setForm(onDemandOnboardingForm)
        }
        // eslint-disable-next-line
    }, []);
    
    
    useEffect(() => {
        if(submitOnboardingData?.status === "success") {
            setTab(3);
        }
        // eslint-disable-next-line
    }, [submitOnboardingData]);
    
    
    return (
        <div className='w-full'>
            
            <DynamicHeadTag headerText="Onboarding" />

            <div className="mx-auto text-center">
                <div className="modal-title">
                Welcome to Earnipay  👋
                </div>
                
                <div className="text-fade-2">
                    Complete your account setup to activate your <br /> account
                </div>
            </div>

            
            <div className='box mt-10'>
                <div className="w-full mx-auto lg:w-2/6 pt-3 pb-10">
                    
                    {tab < 3 && 
                    <div className="mb-6 text-ep-primary-600 font-bold text-center">
                        On-Demand Pay Setup
                    </div>}
                    
                    <Maybe condition={submitOnboardingLoading === true}>
                        <Spinner message="submitting" />
                    </Maybe>
                    
                    <Maybe condition={tab === 1}>
                        <form onSubmit={onStepOneComplete}>
                            <SelectInput label="Salary Date (Every month)" required={true} value={form.onDemandPayrollCutOff || ""} onChange={(e) => setForm({...form, onDemandPayrollCutOff: e.target.value})}>
                                <option value="">Select salary date</option>
                                {[...Array(32).keys()].slice(1).map((ele, index) =>
                                <option key={index} value={ele}>{numberOrdinalSuffix(ele)}</option>
                                )}
                            </SelectInput>
                            
                            <SelectInput label="Withdrawal Fee" required={true} value={form.onDemandPaymentFee || ""} onChange={(e) => setForm({...form, onDemandPaymentFee: e.target.value})}>
                                <option value="">Select who pays withdrawal fee</option>
                                <option value="employer">Business</option>
                                <option value="employee">Employee</option>
                                <option value="shared">Shared</option>
                            </SelectInput>
                            
                            <SelectInput 
                                label="Auto-Withdrawals" 
                                required={true} value={form.autoWithdrawals || ""} 
                                onChange={(e) => setForm({...form, autoWithdrawals: e.target.value})}>
                                <option value="">Select</option>
                                <option value="true">Allow auto-withdrawals: Employees can access their on-demand salary without requiring any approval</option>
                                <option value="false">Require approval: I would approve each withdrawal from my employees before they have access</option>
                            </SelectInput>
                            
                            <button type="submit" className="btn btn-lg btn-block btn-ep-primary mt-8">
                                Next
                            </button>
                        </form>
                    </Maybe>
                    
                    
                    <Maybe condition={tab === 2 && submitOnboardingLoading === false}>
                            <div onClick={() => setTab(1)} className="mb-7 cursor-pointer flex items-center">
                                <IconReturn />
                                <span className="ml-2">Back</span>
                            </div>
                            
                            <Maybe condition={statementDoc === null}>
                                <FileUploader handleChange={(e) => setStatementDoc(e)} name="pdf" multiple={false} types={["pdf"]} onTypeError={(err) => toast.error(err)} onSizeError={(err) => toast.error(err)}>
                                    
                                    <div className="form-group">
                                        <label className='pb-2'>
                                            Company's Bank Statement<span className="form-input-required">*</span>
                                        </label>
                                        
                                        <div className="h-[104px] cursor-pointer border border-gray-300 rounded-md w-full flex items-center justify-center flex-col py-4">
                                            <StatementUpload />
                                            <div className="mt-4 font-medium text-ep-primary-600">
                                                Click to upload <span className="lt-gray font-normal">or drag and drop</span>
                                            </div>
                                        </div>
                                    </div>
                                </FileUploader>
                                
                                <div className="my-7 lt-gray">
                                    The bank statement provided is to see the trend of salary payment over a period of time. No information gotten from business can or will be used for fraudulent purposes.
                                </div>
                            
                            </Maybe>
                            
                            
                            <Maybe condition={statementDoc !== null}>
                                <div className="w-full h-full p-6 bg-[#FBFCFFs] flex items-center justify-center">
                                    <div>
                                        <div className="h-20 flex items-center justify-center">
                                            <StatementUpload />
                                        </div>
                                        <div className="mt-4 flex space-x-4 justify-between items-center">
                                            <div>
                                                <div className="flex space-x-4">
                                                    <div className="max-w-sm ellipsis">{statementDoc?.name?.substring(0, 25)}...</div>
                                                    <div>•</div>
                                                    <div>{getFileSize(statementDoc?.size)}</div>
                                                </div>
                                                <div className="w-full h-1 mt-1 bg-[#10B759] rounded-full"></div>
                                            </div>
                                            <div>
                                                <FontAwesomeIcon icon="times-circle" className="cursor-pointer hover:text-red-500" onClick={() => setStatementDoc(null)} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Maybe>
                            
                                
                            <ButtonLoader loading={uploadLoading} onClick={onStepTwoComplete} className="btn btn-lg btn-block btn-ep-primary mt-8">
                                {uploadLoading ? "Uploading your document" : "Submit"}
                            </ButtonLoader>
                    </Maybe>
                    
                    
                    <Maybe condition={tab === 3}>
                        <div className="hs-20 flex items-center justify-center">
                            <HourGlass />
                        </div>
                        
                        <div className="mb-6 text-ep-primary-600 font-bold text-center">Please wait while we approve your <br /> account</div>
                        
                        <div className="lt-gray text-center">
                            This usually takes up to 3 working days
                        </div>
                        
                        <button onClick={() => setTab(2)} className="btn btn-lg btn-block btn-ep-primary mt-5">
                            Edit Setup Details
                        </button>
                    </Maybe>
                    
                </div>
                
            </div>
            
        </div>
    )
}

export default OnDemandOnboarding;